/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import React, { useCallback, useMemo } from 'react';
import classNames from 'classnames';
import './Pagination.styles.scss';

export const getPaginationPages = (currentPage: number, lastPage: number) =>
  lastPage <= 6
    ? Array(lastPage)
        .fill(1)
        .map((number, index) => number + index)
    : currentPage < 4
    ? [1, 2, 3, 4, '...', lastPage]
    : currentPage > lastPage - 2
    ? [1, '...', lastPage - 3, lastPage - 2, lastPage - 1, lastPage]
    : [
        1,
        '...',
        currentPage - 1,
        currentPage,
        currentPage + 1,
        '...',
        lastPage,
      ];

export const transformValue = (value: number, maxValue: number, minValue = 1) =>
  Math.min(maxValue, Math.max(minValue, value));

type PaginationProps = {
  className?: string;
  lastPage: number;
  showDisabled?: boolean;
  setPage: (num: number) => void;
  currentPage: number;
};

const Pagination: React.FC<PaginationProps> = (props) => {
  const { className, lastPage, showDisabled, currentPage, setPage } = props;

  const classes = classNames('pagination', className);

  const setTo = useCallback(
    (page: string) => {
      setPage(+page);
    },
    [setPage],
  );

  const renderPages = useMemo(
    () =>
      getPaginationPages(+currentPage, +lastPage).map((buttonContent, index) =>
        buttonContent === '...' ? (
          <span key={`span-${buttonContent}-${index}`}>{buttonContent}</span>
        ) : (
          <button
            key={`button-${buttonContent}-${index}`}
            type="button"
            className={classNames({ active: +currentPage === buttonContent })}
            onClick={() => setTo(buttonContent)}
          >
            {buttonContent}
          </button>
        ),
      ),
    [currentPage, lastPage, setTo],
  );

  const prevDisabled = +currentPage === 1;
  const nextDisabled = +currentPage === lastPage;

  return lastPage > 1 ? (
    <div className={classes}>
      {(showDisabled || !prevDisabled) && (
        <button
          type="button"
          className={classNames({ disabled: prevDisabled }, 'prev-next')}
          onClick={() => setTo(String(+currentPage - 1))}
        >
          Prev
        </button>
      )}

      {renderPages}

      {(showDisabled || !nextDisabled) && (
        <button
          type="button"
          className={classNames({ disabled: nextDisabled }, 'prev-next')}
          onClick={() => setTo(String(+currentPage + 1))}
        >
          Next
        </button>
      )}
    </div>
  ) : null;
};

export default Pagination;
